export default {
      id: "ic_trash_dark_red-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_trash_dark_red-usage",
      toString: function () {
        return this.url;
      }
    }